const AutoCampaignTypes = {
    DIVERSITY: 'diversity',
    REGULAR: 'regular',
    HYBRID: 'hybrid',
};

const defaultAssociatedEmployersSettings = {
    isDiversityEnabled: true,
    office: 'OFFICE_RESELLER',
    defaultEmployerRep: '',
    doNotReplyEmail: '',
    settings: {
        defaultCompaniesExcludeOption: -1,
        isGDPR: false,
        isDiversityReportEnabled: true,
        isDiversityTagEnabled: false,
        isContactForEmployerEnabled: true,
        areLinkedinConnectionsEnabled: true,
        isBulkActionsContactByLinkedInEnabled: true,
        isCampaignsAnalysisPageEnabled: true,
        sendersAuthenticateDomain: '',
        shortUrl: '',
        isPositionRecommendationsEnabled: true,
        showAtsRecruiter: false,
        isProfileHiddenDetailsPreviewEnabled: false,
        allowTalenyaDefaultEmployerRepForAtsPositions: false,
        showAtsJobId: true,
        showAtsJobUrl: true,
        atsType: '',
        isPhoneRequired: false,
        isProfileFeedbackModeEnabled: true,
        isNewLandingPageEnabled: true,
        showManageJob: false,
        showWizardSamplesPage: false,
        isJobWizardFastRatingEnabled: true,
        isOnlyFastRatingAllowed: false,
        isSkipCalibrationForSimilarJobsAllowed: false,
        isManualQualifyEnabled: false,
        isManualQualifyManualFlowEnabled: false,
        isManualQualifyLowTalentPoolEnabled: false,
        isManualQualifyManualMessagingEnabled: false,
        isEmployerPostScrapingEnabled: false,
        switchOnAutoCampaignOnCompleteCalibration: true,
        isAutoInviteToRateEnabled: false,
        autoCampaignOptions: {
            autoCampaignType: AutoCampaignTypes.REGULAR,
            selectedDiversityTarget: [],
        },
        interestedCandidateRequiredContacts: [],
        authData: {},
        isUploadMonitorEnabled: true,
        atsTalenyaSourceId: '',
        atsProgrammaticSourceId: '',
        programmaticCampaignType: '',
        isAutoContactAutoSelectEnabled: false,
        isAutoQualifyEnabled: false,
        isAIJobDescriptionGenerationEnabled: false,
        isAtsJobsAutoPushStatusEnabled: false,
        isLineBreakTagInJobDescriptionEnabled: true,
        isCandidateFastApplyEnabled: false,
        isFastCalibrationEnabled: false,
        isMultipleSelectionEnabled: false,
    },
};

export default defaultAssociatedEmployersSettings;
